import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store.js";
import { NextUIProvider } from "@nextui-org/react";
import { HelmetProvider } from "react-helmet-async";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
// import "http://wanijblog.local/wp-content/themes/twentytwentyfour/style.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="1049121200498-mnfho130h5k9j0lkeosses63vq9fra6r.apps.googleusercontent.com">
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <Provider store={store}>
            <NextUIProvider>
              <App />
            </NextUIProvider>
          </Provider>
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
